import { useState } from "react";
import {
  CssBaseline,
  TextField,
  Link,
  Grid,
  Typography,
  Container,
} from "@mui/material";
import { LockOutlined as LockOutlinedIcon } from "@mui/icons-material";
import { useNotify, Notification, useAuthProvider } from "react-admin";
import {
  StyledDiv,
  StyledAvatar,
  StyledForm,
  StyledButton,
  Copyright,
} from "./loginComponents";

export default function SignIn() {
  const authProvider = useAuthProvider();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const notify = useNotify();
  const submit = (e) => {
    e.preventDefault();
    if (!e.currentTarget.reportValidity()) return;
    setIsLoading(true);
    authProvider.forgotPassword(email)
      .then((e) => {
        notify("Please check your email", { type: "success" });
      })
      .catch((e) => {
        const strarr = [];
        if (e.message) strarr.push(e.message);
        if (e.body?.err) {
          for (const key in e.body.err) {
            strarr.push(e.body.err[key]);
          }
        }
        notify(strarr.join("\n"), { type: "warning", multiLine: true });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <StyledDiv>
        <StyledAvatar>
          <LockOutlinedIcon />
        </StyledAvatar>
        <Typography component="h1" variant="h5">
          Reset Password
        </Typography>
        <StyledForm onSubmit={submit} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            type="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <StyledButton
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isLoading}
          >
            Submit
          </StyledButton>
          <Grid container>
            <Grid item>
              <Link href="#/login" variant="body2">
                Sign in
              </Link>
            </Grid>
          </Grid>
          <Notification />
        </StyledForm>
      </StyledDiv>
      <Copyright />
    </Container>
  );
}
